// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-execution/shared/ExecutionActionRow.jsx

import React from "react";
import { ActionGroup } from "../../../design-system/components";

function displayValue(value, fallback = "Action") {
  if (value === null || value === undefined || value === "") return fallback;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  return fallback;
}

function normalizeVariant(action) {
  const variant = String(action?.variant || "").toLowerCase();
  const className = String(action?.className || "").toLowerCase();

  if (variant === "danger" || className.includes("danger")) return "danger";
  if (variant === "primary" || className.includes("primary")) return "primary";
  if (
    variant === "tertiary" ||
    variant === "ghost" ||
    className.includes("ghost")
  ) {
    return "tertiary";
  }
  return "secondary";
}

export default function ExecutionActionRow({ actions = [] }) {
  const normalizedActions = (Array.isArray(actions) ? actions : [])
    .filter(Boolean)
    .map((action, index) => ({
      ...action,
      key: action.key || displayValue(action.label, `action-${index}`),
      label: displayValue(action.label),
      variant: normalizeVariant(action),
      size: action.size || "small",
    }));

  return (
    <ActionGroup
      actions={normalizedActions}
      density="compact"
      className="execution-action-row"
    />
  );
}
